// scroll bar
import 'simplebar/src/simplebar.css';

// lazy image
import 'react-lazy-load-image-component/src/effects/blur.css';
import 'react-lazy-load-image-component/src/effects/opacity.css';
import 'react-lazy-load-image-component/src/effects/black-and-white.css';

import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
// contexts
import axios from 'axios';
import { SettingsProvider } from './contexts/SettingsContext';
import { WebRequestProvider } from './contexts/WebinarContext';
import { CollapseDrawerProvider } from './contexts/CollapseDrawerContext';
//
import App from './App';
import { AuthProvider } from './contexts/AuthContexts';

// ----------------------------------------------------------------------

axios.defaults.timeout = 60000;
// if (process.env.REACT_APP_DEBUG === 'true') {
axios.defaults.baseURL = process.env.REACT_APP_URL_DEBUG;
// } else {
//   axios.defaults.baseURL = process.env.REACT_APP_URL_PRODUCT;
// }

ReactDOM.render(
  <HelmetProvider>
    <AuthProvider>
      <SettingsProvider>
        <CollapseDrawerProvider>
          <BrowserRouter>
            <WebRequestProvider>
              <App />
            </WebRequestProvider>
          </BrowserRouter>
        </CollapseDrawerProvider>
      </SettingsProvider>
    </AuthProvider>
  </HelmetProvider>,
  document.getElementById('root')
);
